import { Menu, MenuItem, Button, Icon } from "@nike/eds";
import React,{ FC, useState,useContext } from "react";
import { CaretDown, CaretUp } from "@nike/nike-design-system-icons";
import { NikeI18nContext } from '@nike/i18n-react';
import { useLanguageContext } from '../context/language/context';
import { Languages } from '../models/translations';
import styles from './layout.module.css'

export const LanguageMenu: FC = () => {
  
    const [language, setLanguage] = useLanguageContext();
    const {supportedLanguages} = useContext(NikeI18nContext);

    const [languageMenuAnchor, setLanguageMenuAnchor] = useState<null | HTMLElement>(null);
    const isLanguageMenuOpen = Boolean(languageMenuAnchor);

    const handleOpenLanguageMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        isLanguageMenuOpen ?  setLanguageMenuAnchor(null):setLanguageMenuAnchor(event.currentTarget);
    };
    const handleCloseLanguageMenu = () => {
        setLanguageMenuAnchor(null);
    };
    const handleLanguageChange = (lang: Languages) => () => {
        setLanguage(lang);
        handleCloseLanguageMenu();
    };
    const body = (
        <>{supportedLanguages?.map(({ name, tag }) => (
            <MenuItem key={tag} onClick={handleLanguageChange(tag as Languages)}>
                {name}
            </MenuItem>
        ))}
        </>
    );

    return (<Menu
        bodySlot={body}
        placement={"bottom-start"}
        isOpen={isLanguageMenuOpen}
        onClickOutside={() => {  handleCloseLanguageMenu() }}
        className={styles.language_menu}
        id="language-menu"
    >
        <Button
            afterSlot={isLanguageMenuOpen ? <CaretUp /> : <CaretDown />}
            variant="ghost"
            onClick={handleOpenLanguageMenu}
            aria-expanded={isLanguageMenuOpen ? 'true' : undefined}
            aria-haspopup='true'
            aria-controls='language-menu'
            size="small">
             <Icon
                name="Translation"
                backgroundColor="var(--eds-color-grey-2)"
            /> {supportedLanguages?.find(({ tag }) => tag === language)?.name}
        </Button>
    </Menu>
    );
}